import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CargoIntegrationInput, CargoIntegrationResult, GetCargoIntegrationsInput, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class CargoIntegrationService {

  constructor(private httpClient: HttpClient) { }

  public addCargoIntegration(cargoIntegrationInput: CargoIntegrationInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'CargoIntegration/AddCargoIntegration', cargoIntegrationInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editCargoIntegration(id: number, cargoIntegrationInput: CargoIntegrationInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'CargoIntegration/EditCargoIntegration?id=' + id, cargoIntegrationInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteCargoIntegration(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'CargoIntegration/DeleteCargoIntegration?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getCargoIntegrations(getCargoIntegrationsInput: GetCargoIntegrationsInput): Promise<ResultList<CargoIntegrationResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'CargoIntegration/GetCargoIntegrations', getCargoIntegrationsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<CargoIntegrationResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<CargoIntegrationResult>(), result.error));
  }
}